import { FC, ReactNode } from 'react'
import useVisualViewPort from 'hooks/useVisualViewPort'
import MobileBottomModal from 'components/mobile/MobileBottomModal'

const MOBILE_MODAL_VERTICAL_OFFSET = 10
export const MOBILE_POST_FORM_LOCATION_INPUT_PORTAL_ID =
  'mobile-post-form-location-input-portal'

type MobilePostFormProps = {
  open?: boolean
  title?: string
  onCloseModal?: () => void
  content: ReactNode
  footer: JSX.Element | null
  children?: ReactNode
}

const MobilePostForm: FC<MobilePostFormProps> = ({
  open,
  title,
  onCloseModal,
  content,
  footer,
  children,
}) => {
  const [viewPortHeight] = useVisualViewPort()

  return (
    <MobileBottomModal
      open={open}
      onCloseModal={onCloseModal}
      title={title}
      showClose
      className="flex flex-col [&_[data-testid=create-post-section]]:flex-1"
      style={{
        height: Math.max(viewPortHeight - MOBILE_MODAL_VERTICAL_OFFSET, 0),
      }}
      childrenClassName="flex-1 !max-h-none"
      renderFooter={() => footer}
      renderContent={() => (
        <>
          <div
            id={MOBILE_POST_FORM_LOCATION_INPUT_PORTAL_ID}
            className="mb-l empty:hidden"
          />
          {content}
          {children}
        </>
      )}
    />
  )
}

export default MobilePostForm
